/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { notify } from 'react-notify-toast';
import { useHistory } from 'react-router-dom';
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from 'recharts';
import {
  Button,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from 'react-bootstrap';
import LoadingScreen from '../../Layout/LoadingScreen';
import clientAxios from '../../clients/clientAxios';

const ClassroomStatistics = () => {
  const history = useHistory();
  const LASTADDED_CLASSROOMS = 10;
  const DEFAULT_PUBLISHED = false;
  const [isLoading, setIsLoading] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [display, setDisplay] = useState({
    isActive: 'active',             
    lastAdded: LASTADDED_CLASSROOMS, 
    published: DEFAULT_PUBLISHED,   
  });

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const { data } = await clientAxios(
        '/graph/studentsInClassroomCount',
        {
          headers: { 'auth-token': localStorage.getItem('JWT') || ' ' },
          params: {
            classroomIsActive: display.isActive,
            published: display.published,
            lastAdded: display.lastAdded,
          },
        }
      );
      setChartData(data.data);
      setIsLoading(false);
    } catch (err) {
      notify.show(err.message, 'error');
      history.push('/');
    }
  };
  useEffect(() => {
    fetchData();
  }, [display]);
  const clearSearch = () => {
    setDisplay({
      isActive: 'active',
      lastAdded: LASTADDED_CLASSROOMS,
      published: DEFAULT_PUBLISHED,
    });
  };

  if (isLoading) return <LoadingScreen />;

  return (
    <Container className='mb-5 pl-0 pr-0'>
      <Container className='bg-light rounded shadow p-3 pl-0 mb-5'>
        <Form>
          <Row className='mb-2'>
            <Col>
              <Button
                variant={display.isActive === 'active' ? 'dark' : 'outline-dark'}
                onClick={() =>
                  setDisplay({ ...display, isActive: 'active' })
                }
              >
                Activos
              </Button>

              <Button
                className='ml-2'
                variant={display.isActive === 'down' ? 'dark' : 'outline-dark'}
                onClick={() =>
                  setDisplay({ ...display, isActive: 'down' })
                }
              >
                Bajas
              </Button>
            </Col>

            <Col>
              <InputGroup>
                <InputGroup.Prepend>
                  <InputGroup.Text>Comisiones</InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  as='select'
                  value={display.lastAdded}
                  onChange={(e) =>
                    setDisplay({
                      ...display,
                      lastAdded: Number(e.target.value),
                    })
                  }
                >
                  <option value={10}>Últimas 10</option>
                  <option value={20}>Últimas 20</option>
                </Form.Control>
              </InputGroup>
            </Col>

            <Col xs={3}>
              <Button className='w-100' onClick={clearSearch}>
                Limpiar búsqueda
              </Button>
            </Col>
          </Row>

          <Form.Check
            type='checkbox'
            label='Solo comisiones publicadas'
            checked={display.published}
            onChange={(e) =>
              setDisplay({ ...display, published: e.target.checked })
            }
          />
        </Form>
      </Container>

      <div
        className='container d-flex bg-light rounded shadow p-3 align-items-center'
        style={{ height: '60vh' }}
      >
        {chartData.length === 0 ? (
          <p>No hay datos para mostrar.</p>
        ) : (
          <ResponsiveContainer width='100%' height='100%'>
            <BarChart
              data={chartData}
              barSize={30}
              margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
            >
              <CartesianGrid strokeDasharray='1 1' />
              <XAxis
                dataKey='classroom'
                interval={0}
                angle={-35}
                textAnchor='end'
                tick={{ fontSize: 8 }}
              />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar
                dataKey='activeStudentsCount'
                name='Alumnos por classroom'
                fill='#78cb7d'
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </Container>
  );
};

export default ClassroomStatistics;